const MOCK_SEARCH = {
  hots: [
    "菜單",
    "寄件",
    "交通車",
    "報修"
  ]
};

export default MOCK_SEARCH;
